/**
 * What goes on the sheet. Chosen on the sheet page, remembered per browser, never sent to
 * the server: the sheet is a document the player composes, not state the core owns.
 */
export type Paper = "a4" | "letter";

export interface SheetOptions {
  paper: Paper;
  /** The rules under the puzzle. Off for a solver who already knows the variant. */
  rules: boolean;
  /** A second page with the puzzle alone: for a fresh attempt, or for a second solver. */
  secondCopy: boolean;
  /** The puzzle's address as a QR code at the foot, so the answer is a scan away from paper. */
  qr: boolean;
}

export const DEFAULT_OPTIONS: SheetOptions = {
  paper: "a4",
  rules: true,
  secondCopy: false,
  qr: true,
};

const STORAGE_KEY = "bt-sheet-options";

export function loadOptions(): SheetOptions {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return DEFAULT_OPTIONS;
    const stored = JSON.parse(raw) as Partial<SheetOptions>;
    return {
      paper: stored.paper === "letter" ? "letter" : "a4",
      rules: stored.rules !== false,
      secondCopy: stored.secondCopy === true,
      qr: stored.qr !== false,
    };
  } catch {
    return DEFAULT_OPTIONS;
  }
}

export function saveOptions(options: SheetOptions): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(options));
  } catch {
    // Storage unavailable: the choice lasts for this page only.
  }
}
